import { defineMessages } from 'react-intl-next';

const messagesBase = defineMessages({
	createTemplate: {
		id: 'snippets.createTemplate',
		defaultMessage: 'Create template',
		description: 'Label for the create template button in the contextual toolbar',
	},
	createTemplateLozenge: {
		id: 'snippets.createTemplateLozenge',
		defaultMessage: 'New',
		description: 'Lozenge label for the create template button in the contextual toolbar',
	},
});

export const messages = messagesBase;
